<template>
  <b-tabs>
    <b-tab title="In Queue" active>
      <scan-queue />
    </b-tab>
    <b-tab title="Scanning">
      <scan-scanning />
    </b-tab>
    <b-tab title="Scanned Tags">
      <scan-completed />
    </b-tab>
  </b-tabs>
</template>

<script>
  import ScanQueue from "./components/ScanQueue"
  import ScanScanning from "./components/ScanScanning"
  import ScanCompleted from "./components/ScanCompleted"

  export default {
      components: {
          ScanQueue,
          ScanScanning,
          ScanCompleted
      }
  }
</script>



// WEBPACK FOOTER //
// src/demand/pages/ScanTabs.vue